const getDropdownMappingWithNewOptions = (dropdownsMappings, key, newOptions) => ({
  ...dropdownsMappings,
  [key]: { ...dropdownsMappings[key], options: newOptions },
});
export default getDropdownMappingWithNewOptions;
